import { render, staticRenderFns } from "./PatientSearchForm.vue?vue&type=template&id=4e2bff28"
import script from "./PatientSearchForm.vue?vue&type=script&lang=js"
export * from "./PatientSearchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports